import { SportsApiClient } from '@sports/core'
import { useFeed } from './use-feed'

/**
 * UI-label translator for a widget. Fetches the locale's labels from the hub
 * (`/v1/ui`, which overlays CMS edits on the shipped defaults) and returns a
 * `t(key, fallback)` — the English `fallback` renders instantly and is replaced
 * once the labels load, so a widget is never blank or wrong-language-blocking.
 */
export function useLabels(base: string, lang: string): (key: string, fallback: string) => string {
  const client = new SportsApiClient(base)
  const { data } = useFeed(
    (signal) => client.uiLabels(lang, signal),
    [base, lang],
    0,
  )
  return (key: string, fallback: string): string => data?.[key] || fallback
}
